"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSDebugger = void 0;
var React = require("react");
var context_1 = require("../context");
/** [[include:components/debugger.md]] */
var SSDebugger = /** @class */ (function (_super) {
    __extends(SSDebugger, _super);
    function SSDebugger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @hidden */
    SSDebugger.prototype.render = function () {
        var output = {
            ready: this.context.searchspring.ready,
            loading: this.context.searchspring.loading,
            options: this.context.searchspring.options,
            query: this.context.searchspring.query,
            current: this.context.searchspring.current,
        };
        if (!this.props.hasOwnProperty("console") || this.props.console === true) {
            console.warn("[debug]", output); // tslint:disable-line
        }
        if (!this.props.dom) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("pre", null, JSON.stringify(output, null, 2))));
    };
    /** @hidden */
    SSDebugger.contextType = context_1.Context;
    return SSDebugger;
}(React.PureComponent));
exports.SSDebugger = SSDebugger;
//# sourceMappingURL=debugger.js.map